import Mason from "./components/Mason";
import { Route, Link,Redirect, BrowserRouter as Router } from 'react-router-dom'
import Login from "./components/Login";
import Signup from "./components/Signup";

function App() {
  return (
    <Router>
      <div >
        <Route exact path="/">
          <Redirect to="/login" />
        </Route>
        <Route exact path="/group/:group" component={Mason} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/signup" component={Signup} />
      </div>
    </Router>
  );
}

export default App;
